import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder } from '@angular/forms';

//shared libs
import { Location } from '@angular/common';
//import { UserSessionService, PatientParms } from '../../shared';
import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { PatientVM } from '../../patients';
import { NicuVaccineScheduleService, NicuVaccinTrans } from './nicu-vaccine-schedule.service';
import { ToastService } from '../../../blocks';
import { UserSessionService } from '../../../app-user-session.service';
import { PatientParms, getNgBsObj, getDateObj } from '../../../shared';

@Component({
    selector: 'nicu-vaccine-schedule',
    templateUrl: './nicu-vaccine-schedule.component.html',

})

export class NicuVaccineScheduleComponent implements OnInit, AfterViewInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @ViewChild('btnCtrl1') btnCtrl: any;
    patients: [] = [];
    newBornList: any[] = [];
    nicuVaccinTransList: NicuVaccinTrans[] = []
    _NicuVaccinTransObjCopy: NicuVaccinTrans = <NicuVaccinTrans>{}
    _NicuVaccinTransObj: NicuVaccinTrans = <NicuVaccinTrans>{}
    patientSearchObj: PatientVM = <PatientVM>{};
    showaddNewBornNicuVaccinBtn: boolean
    motherData: PatientVM = <PatientVM>{};
    newBornCode: number;
    showDocId: boolean
    showDate: boolean
    flagPatient: number;
    showInOutHospitalFalg: boolean;
    patientParms: PatientParms = <PatientParms>{};
    constructor(
        public translate: TranslateService,
        private _location: Location,
        private _NicuVaccineScheduleService: NicuVaccineScheduleService,
        private _toastService: ToastService,
        private _userSessionService: UserSessionService,


    ) { }
    //-------------------------------------------------------------------------------------------------------------keys.value["code"]--------
    ngOnInit() {
        // let inputsObj = this._userSessionService.getModalKey('NicuVaccineScheduleComponent');

        // if (inputsObj && inputsObj["inputs"]) {
        //     let inputs = inputsObj["inputs"];
        //     this.patientParms.patCode = inputs['code'];
        //     this.getInputsAsPopub$();
        // }
        // else {
        //let _patientForEdit = this._userSessionService.subscribeToKey$('patientForEdit');
        this._userSessionService.subscribeToKey$('patientForEdit').pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys && keys.value) {
                    let _patientForEdit = keys.value;
                    if (_patientForEdit) {
                        this.patientParms.patCode = _patientForEdit['code'];
                    }

                }
            });

        this._userSessionService.subscribeToKey$('patient').pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys && keys.value) {
                    this.flagPatient = keys.value.flagPatient
                    this.newBornCode = keys.value.patientCode
                    this.getNicuVaccin(this.newBornCode)
                }
            });
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    onSearchClick(_searchOnj: any) {
        this.newBornList = [];
        this.nicuVaccinTransList = [];
        this.patientSearchObj = _searchOnj;
        this.patientSearchObj.offset = 0;
        this.patientSearchObj.pageSize = 20;
        this.searchMotherPat();
    }

    searchMotherPat() {
        this.newBornList = [];
        this._NicuVaccineScheduleService.getMotherPat(this.patientSearchObj).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(
                requests => {
                    if (requests && requests.data.length > 0) {
                        this.showaddNewBornNicuVaccinBtn = true
                        this.newBornList = requests.data
                    }
                },
                error => console.log(error),
                () => { });
    }

    onActionIconsClicked(markPatService) {
        this.newBornList.forEach(element => {
            element.selectedRow = false
        });
        if (markPatService) {
            markPatService.selectedRow = true;
            this.newBornCode = markPatService.babyPatCode
            this.getNicuVaccin(this.newBornCode)
        }
    }

    getNicuVaccin(newBornCode) {
        this.nicuVaccinTransList = [];
        this._NicuVaccineScheduleService.getNicuVaccin(newBornCode)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(res => {
                this.nicuVaccinTransList = res.data
            })
    }

    onRowClicked(operation, item: NicuVaccinTrans, modal) {
        switch (operation) {
            case 404:
                this._NicuVaccinTransObjCopy = <NicuVaccinTrans>{}
                item.updatestatus = 2
                this._NicuVaccinTransObjCopy = Object.assign({}, item)
                item.vaccinationDate = getNgBsObj(item.vaccinationDate)
                break;
            default:
                break;
        }
    }



    undoEdit(item: NicuVaccinTrans) {
        let rowIndex = this.nicuVaccinTransList.findIndex(
            ele => ele.serial === item.serial
        );
        this._NicuVaccinTransObjCopy.updatestatus = 1
        this.nicuVaccinTransList[rowIndex] = this._NicuVaccinTransObjCopy
        let date = getDateObj(this._NicuVaccinTransObjCopy.vaccinationDate)
        this.nicuVaccinTransList[rowIndex].vaccinationDate = date
        item.updatestatus = 1
        this._NicuVaccinTransObjCopy = <NicuVaccinTrans>{}
    }

    // deleteRow(item: NicuVaccinTrans) {
    //     let rowIndex = this.nicuVaccinTransList.findIndex(
    //         ele => ele.serial === item.serial
    //     );
    //     if (this.nicuVaccinTransList[rowIndex].serial < 0) {
    //         this.nicuVaccinTransList.splice(rowIndex, 1)
    //     }
    //     else {
    //         this.nicuVaccinTransList[rowIndex].dataStatus = 3
    //     }
    // }

    deleteRow(item: NicuVaccinTrans) {
        this._NicuVaccineScheduleService.deleteNicuVaccineSchedule(item.serial).pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((res) => { },
                error => console.log(error),
                () => { this.getNicuVaccin(item.newBornCode); })
    }

    // getNicuCssClasses = (item, rowIndex: number) => {
    //     if (item && item.dataStatus == 3) {
    //         return 'deleted-row';
    //     }
    //     else {
    //         return ''
    //     }
    // }

    getOrderActionIcon(item: NicuVaccinTrans) {
        let appCodes = [];
        appCodes = ['404'];
        return appCodes;
    }

    getCssClasses = (item, rowIndex: number) => {
        if (item && item.selectedRow == true) {
            return 'bg-warning';
        }
        else {
            return ''
        }
    }


    onNewBornRowClicked(ev, item, mode) {

    }
    onClicked(e: number): void {
        switch (e) {
            case 1: //save code
                this.save();
                break;

            default:
                this.cancel();
        }
    }


    cancel(showToast = true) {
        this._goBack();
    }

    _goBack(): void {
        this._location.back();
    }

    addNicuVaccin(ev) {
        let date = (new Date())
        console.log(date)
        if (ev) {

            for (let i = 0; i < ev.length; i++) {

                //validation --------------
                let v = this.nicuVaccinTransList.find(x => x.vaccinSerial == ev[i].code)
                if (v && Object.keys(v).length > 0) {
                    this._toastService.activateMsg('UI38', ev[i].code + ' ' + (this.translate.currentLang == 'ar' ? ev[i].nameAr : ev[i].nameEn));
                    return false;
                }
                // -------------------------

                let row = <NicuVaccinTrans>{};
                row.serial = (i + 1) * (-1);
                row.vaccinSerial = ev[i].code;
                row.vaccinationDate = getNgBsObj(date);
                row.vaccinNameAr = ev[i].nameAr;
                row.vaccinNameEn = ev[i].nameEn;
                row.newBornCode = this.newBornCode;
                row.inOutHospitalFalg = 1;
                row['updatestatus'] = 2;
                row.docId = null;
                row.notes = '';
                this.nicuVaccinTransList.push(row);
            }
        }
    }

    save() {
        let nicuVaccinTransTempList = [];
        for (let index = 0; index < this.nicuVaccinTransList.length; index++) {
            var nicuVaccinTransObj = <NicuVaccinTrans>
                {
                    serial: this.nicuVaccinTransList[index].serial,
                    newBornCode: this.newBornCode,
                    vaccinSerial: this.nicuVaccinTransList[index].vaccinSerial,
                    vaccinationDate: getDateObj(this.nicuVaccinTransList[index].vaccinationDate),
                    docId: this.nicuVaccinTransList[index].docId,
                    inOutHospitalFalg: this.nicuVaccinTransList[index].inOutHospitalFalg,
                    dataStatus: this.nicuVaccinTransList[index].dataStatus,
                    notes: this.nicuVaccinTransList[index].notes
                }

            nicuVaccinTransTempList.push(nicuVaccinTransObj);
        }
        this._NicuVaccineScheduleService.addNicuVaccineSchedule(nicuVaccinTransTempList)
            .subscribe(c => { },
                error => console.log(error),
                () => {
                    this.getNicuVaccin(this.newBornCode)
                }
            )
    }

    togglefillter() {
        return true;
    }


    // // getInputsAsPopub$() {
    // //     this._userSessionService.getModalKey$().pipe(
    // //         takeUntil(this.ngUnsubscribe))
    // //         .subscribe((keys: any) => {
    // //             if (keys.name == 'NicuVaccineScheduleComponent' && keys.inputs) {
    // //                 this.patientParms.patCode = keys.inputs['code'];
    // //                 this.getNicuVaccin(this.newBornCode);
    // //             }
    // //         });
    // // }

}
